import React, { Component } from 'react';
import { connect } from 'react-redux';
import { path } from 'ramda';
import ColorPicker from '../../common/СolorPicker';
import ProfileBaseForm from '../../common/ProfileBaseForm';
import ProfileChangePassword from '../../common/ProfileChangePassword';
import { getUserColor, updateUserProfile } from '../../api/profile';
import { dissmissProfileSuccessMessage } from '../../actions/profile';
import Alert from '../../ui-elements/alerts/Alert';
import Input from '../../common/Input';
import '../../css/ui-elements/buttons.css';
import {fields } from './fields';
import { linkDataToFields } from '../../utils/fields';
import { processFields } from '../../utils/prePost';
import {validateFields} from "../../utils/validate";
import Wysisyg from '../../common/Wysisyg';

import './style.css';

class Profile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userProfile: {},
      fields,
      fieldsSync: false,
      showChangePassword: false,
      errorMessage: '',
      currentPassword: '',
    };
    this.changePassword = this.changePassword.bind(this);
    this.saveData = this.saveData.bind(this);
    this.onChange = this.onChange.bind(this);
    this.saveColor = this.saveColor.bind(this);
  }

  updatePage = () => {
    if (this.state.fieldsSync === false) {
      const profile = path(['users', 'userProfile'], this.props);
      if (profile) {
        const fields = linkDataToFields(profile, this.state.fields, null, fields);
        this.setState({
          fields: fields,
          fieldsSync: true,
          currentPassword: profile.password
        });
      }
    }
  }

  componentDidMount() {
    this.updatePage();
  }

  componentDidUpdate() {
    this.updatePage();
  }

  changePassword() {
    this.setState({
      changePassword: !this.state.changePassword
    });
  }

  onToggleChangePassword = () => {
    this.setState(state => {
      const fields = {...state.fields};
      const isRequired = !state.showChangePassword;

      ['currentpassword', 'newpassword', 'verifypassword']
          .forEach(key => {
            if(isRequired) fields[key].rules.required = true;
            else delete fields[key].rules.required;
          });

      return {
        ...state,
        showChangePassword: !state.showChangePassword,
        fields
      }
    })
  };

  saveData() {
    const {userProfile, showChangePassword} = this.state;
    let passwordData = {shouldUpdatePassword: false};

    const result = validateFields(this.state.fields);
    showChangePassword && this.isNewPasswordDataValid(result);

    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    }else {
      const data = processFields(this.state.fields);

      const {currentpassword, newpassword} = this.state.fields;
      passwordData = {shouldUpdatePassword: true, currentpassword, newpassword};

      this.props.save({...data, ...passwordData, ...userProfile});
    }
  }

  isNewPasswordDataValid(checkResult) {
    const {currentpassword, newpassword, verifypassword} = this.state.fields;

    if(currentpassword.value && !this.doesOldPasswordMatchInput(currentpassword)) {
      checkResult.fields.currentpassword.errors.push('The old password you entered is not correct. Please try again.');
      checkResult.check = false;
    }

    const newPasswordIsValid = !!newpassword && !!verifypassword && newpassword.value === verifypassword.value;

    if(!newPasswordIsValid){
      checkResult.fields.verifypassword.errors.push('Password does not match. Check your "Caps Lock" key and try again');
      checkResult.check = false;
    }

    return true;
  }

  doesOldPasswordMatchInput(input) {
    return input.value === this.props.users.userProfile.password;
  }

  saveColor(data) {
     this.setState({
       userProfile: data
     });
  }

  onChange(fieldname, fieldvalue) {
    let fields = this.state.fields;
    fields[fieldname] = fieldvalue;
    this.setState({fields: fields});
  }

  render() {
    const profileColor = path(['profile', 'job_card_color_id'], this.props);
    const {showChangePassword} = this.state;
    return (
      <div style={{ paddingBottom: '25px' }}>
        <div className={'card rounded'}>
          <div className={'card-header rounded-top'}>
            Profile
          </div>
          <div className={'card-block'}>
              <div className={'col-12'} style={{ paddingBottom: '40px' }}>
                {/* <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className={'fa fa-remove'}></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button> */}
                <button
                  className={'btn btn-success btn-outline float-right'}
                  onClick={this.saveData}
                  style={{ marginLeft: '10px' }}
                >
                  <i className={'fa fa-check'}></i>
                  <span style={{ paddingLeft: '3px' }}>Save</span>
                </button>
              </div>
              <div className="col-12">
                <label><b>Profile color:</b></label>
                <ColorPicker handler={this.saveColor} currentColor={profileColor} />
              </div>
              <div className={'col-12'} style={{ marginTop: '10px' }}>
                <Input
                  field={this.state.fields['firstname']}
                  onChange={this.onChange}
                />
                <Input
                  field={this.state.fields['lastname']}
                  onChange={this.onChange}
                />
                <Input
                  field={this.state.fields['username']}
                  onChange={this.onChange}
                />
                <Input
                  field={this.state.fields['email']}
                  onChange={this.onChange}
                />
                <Wysisyg
                    field={this.state.fields['signature']}
                    onChange={this.onChange}
                  />                
                <a id="toggle-change-password"
                  onClick={this.onToggleChangePassword}>
                  Change password
                </a>
                {showChangePassword &&
                  <div>
                    <Input
                      field={this.state.fields['currentpassword']}
                      onChange={this.onChange}
                    />
                    <Input
                      field={this.state.fields['newpassword']}
                      onChange={this.onChange}
                    />
                    <Input
                      field={this.state.fields['verifypassword']}
                      onChange={this.onChange}
                    />
                  </div>
                }
              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    save: (data) => {
      updateUserProfile(data)(dispatch);
    },
    getColor: () => {
      getUserColor()(dispatch);
    },
    profileDidUpdate: (data) => {
      dispatch(dissmissProfileSuccessMessage(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/containers/Profile/index.js